import axios from 'axios';
import Vue from 'vue';
import router from '../router';

axios.defaults.baseURL = '/api/'  // 每个请求路径都会带/api
axios.defaults.withCredentials = true
axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.timeout = 300000
//  请求拦截
axios.interceptors.request.use(
    (config) => {
        let token = Vue.prototype.newCommon.getCookie('session')
        config.headers['Authorization'] = token  // 让每个请求都带上token
        if (config.url.indexOf('getmyreceivecount') == '-1' && config.url.indexOf('tipmyoutclaim') == '-1' && config.url.indexOf('getusercalllistremark') == '-1') {
            Vue.prototype.newCommon.showFullScreenLoading();
        }
        return config;
    },
    (err) => {
        Vue.prototype.newCommon.tryHideFullScreenLoading();
        Vue.prototype.newCommon.message({
            status: '-1',
            message: '请求超时',
            type: 'error',
        });
        return Promise.resolve(err);
    }
);

//  响应拦截
axios.interceptors.response.use(
    (res) => {
        Vue.prototype.newCommon.tryHideFullScreenLoading();
        if (res.data.status !== 1 || res.data.status === 0) {
            let msg = res.data.msg;
            Vue.prototype.newCommon.message({
                message: msg , //+ '错误状态码' + res.data.status
                status: res.data.status,
                type: 'error',
            });
            return false;
        }
        return res.data;
    },
    (err) => {
        Vue.prototype.newCommon.tryHideFullScreenLoading();
        if (err.response.status == 500 ) {
            Vue.prototype.newCommon.message({
                message: '服务器被吃了⊙﹏⊙∥,请联系Y001(渣男)!',
                type: 'error',
            });
        } 
        return Promise.resolve(err);
    }
);


const api = {
    get(url, data) {
        return axios.get(url,{ params: data })
    },
    post(url, data) {
        return axios.post(url, JSON.stringify(data))
    }
}

export { axios,api };



// WEBPACK FOOTER //
// ./src/server/http.js